import React from 'react';
import PropTypes from 'prop-types';

import { useUnit } from 'hooks/units/index';
import styles from 'styles/Unit.module.scss';
import moment from 'moment';
import styled from '@emotion/styled';
import { Col, Row } from 'reactstrap';
import { parseHtml, showDurationTime } from 'helpers';
import { Divider } from 'antd';
import { formatDDMMYYYYHHMM } from 'helpers/format-time';
const Stylescal = styled.div`
  .strong {
    text-align: center;
    font-size: 25px;
    color: #52616b;
    font-weight: 700;
    border-radius: 8px;
  }
  .strong-two {
    text-align: center;
    font-size: 22px;
    color: rgb(8, 8, 8);
    font-weight: 700;
  }
  .small-card-value {
    margin: 10px;
    border-radius: 4px;
    background-color: #ececec;
    display: flex;
    justify-content: center;
    padding: 5px 15px;
    text-align: center;
    max-height: 36px;
    border-radius: 8px
    font-size: 18px;
  }

  .key-color {
    color: #8D9398;
    font-weight: 400;
    margin-right: 8px;
    font-size: 16px;

  }
  & > div img {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
  }
    .value-bold{
    font-weight: 400;
    font-size: 16px;
   
    color: #333333;
    }
`;
const ContentStart = ({ content, componentBtnStart }) => {
  const unitSelected = useUnit();
  const config = unitSelected?.config;

  const now = moment();
  const isAfterDate =
    unitSelected?.time?.end && now.isAfter(moment(unitSelected?.time?.end));

  return (
    <div className="m-2">
      {/* <h2 className="bold text-center">{content}  </h2> */}

      <Stylescal>
        {' '}
        <div className="strong">{unitSelected?.title}</div>
        <div className="d-flex justify-content-center mt-2 flex-wrap">
          {unitSelected?.totalQuesiton ? (
            <div className="small-card-value">
              <div className="key-color">Questions</div>
              <div className="value-bold">
                {' '}
                :{' '}
                {unitSelected?.reAttempt
                  ? unitSelected?.totalFaiedQuestions
                  : unitSelected?.totalQuesiton || 0}{' '}
              </div>
            </div>
          ) : null}

          {unitSelected?.time?.begin ? (
            <div className="small-card-value">
              <div className="key-color">Start Date</div>
              <div className="value-bold">
                : {formatDDMMYYYYHHMM(unitSelected?.time?.begin)}
              </div>
            </div>
          ) : null}

          {unitSelected?.time?.due ? (
            <div className="small-card-value">
              <div className="key-color">Due Date</div>
              <div className="value-bold">
                : {formatDDMMYYYYHHMM(unitSelected?.time?.due)}
              </div>
            </div>
          ) : null}

          {unitSelected?.time?.end ? (
            <div className="small-card-value">
              <div className="key-color">End Date</div>
              <div className="value-bold">
                : {formatDDMMYYYYHHMM(unitSelected?.time?.end)}
              </div>
            </div>
          ) : null}

          {!isAfterDate && config?.orginalDuration > 0 ? (
            <div className="small-card-value">
              <div className="key-color">Duration</div>
              <div className="value-bold">
                : {Math.floor(config?.orginalDuration)} mins
              </div>
            </div>
          ) : null}
        </div>
        <div></div>
      </Stylescal>

      {/* {!isAfterDate && config?.duration > 0 && (
        <p className="text-center">
          You have {config?.duration} minutes to complete it
        </p>
      )} */}
      {/* {(config?.message || unitSelected?.description) && (
        <p className={styles.description}>
          {unitSelected?.config?.message || unitSelected?.description}
        </p>
      )} */}

      <Divider />

      {config?.message && (
        <Stylescal>
          {/* <Row>
            <Col>
              <div className="strong-two">Quiz Instructions</div>
            </Col>
          </Row> */}
          {parseHtml(config?.message)}
        </Stylescal>
      )}
      <div className="text-center">{componentBtnStart}</div>
    </div>
  );
};

ContentStart.propTypes = {
  content: PropTypes.string.isRequired,
  componentBtnStart: PropTypes.any,
};

export default ContentStart;
